<template>
    <h3 class="mt-l">Configuration templates</h3>
    <p>Select configuration format to generate (opens in a new tab)</p>
    <form method="GET" target="_blank" :action="url">
        <div id="config-div">
        <CustomSelect
            title="Select format"
            :options="options"
            @option-selected="getSelected"
        />    
        <button :disabled="selected === ''" id="config-generate" type="submit" @click="configClicked">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#ffffff">
                <path d="M5.3 20.5q-.75 0-1.275-.525Q3.5 19.45 3.5 18.7V5.3q0-.75.525-1.275Q4.55 3.5 5.3 3.5h6.325V5H5.3q-.1 0-.2.1t-.1.2v13.4q0 .1.1.2t.2.1h13.4q.1 0 .2-.1t.1-.2v-6.325h1.5V18.7q0 .75-.525 1.275-.525.525-1.275.525Zm4.425-5.175-1.05-1.05L17.95 5H14V3.5h6.5V10H19V6.05Z"/>
            </svg>
            Generate
        </button>
        </div>
    </form>
</template>

<script>

import CustomSelect from './CustomSelect.vue';


export default {
    name: "ConfigGeneration",
    props: ["prjnum", "access_key"],
    emits: ["config-clicked"],
    components: { CustomSelect },
    data() {
        return {
            options: ["shell", "boto3", "rclone", "s3cmd", "aws"],
            selected: ""
        };
    },
    methods: {
        configClicked() {
            this.emitter.emit("config-clicked");
        },
        getSelected(option) {
            this.selected = option;
        }
    },
    computed: {
        url() {
            return "/projects/" + this.prjnum + "/keys/" + this.access_key + "/conf/" + this.selected;
        }
    }
}
</script>

<style>
#config-div {
    display: inline-flex;
    gap: 1rem;
}
</style>
